var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_setup.question.loading),expression:"question.loading"}],staticClass:"question-overview"},[(_setup.qnaList.length)?_c(_setup.QuestionList,{attrs:{"listData":_setup.qnaList,"isDetails":false}}):_c('Empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }